import { Link } from 'react-router-dom';

export default function InternalLinkingHub() {
  const links = [
    {
      icon: 'ri-bar-chart-box-line',
      title: 'Mulebuy Spreadsheet Comparison 2026',
      desc: 'See how top systems stack up in our comprehensive ranking',
      url: '/mulebuy-spreadsheet-comparison-2026',
      image: 'https://readdy.ai/api/search-image?query=Clean%20modern%20desk%20setup%20with%20a%20laptop%20showing%20comparison%20charts%20and%20graphs%20on%20screen%2C%20a%20notebook%20with%20handwritten%20analysis%20beside%20it%2C%20warm%20morning%20light%20from%20a%20nearby%20window%2C%20organized%20professional%20workspace%20with%20sage%20green%20and%20cream%20tones%2C%20business%20analytics%20and%20research%20photography%20with%20focused%20and%20methodical%20atmosphere&width=600&height=240&seq=link-compare-v2&orientation=landscape'
    },
    {
      icon: 'ri-book-open-line',
      title: 'How Mulebuy Spreadsheet Works',
      desc: 'A complete beginner guide to getting started fast',
      url: '/article/mulebuy-spreadsheet-beginners-guide',
      image: 'https://readdy.ai/api/search-image?query=Person%20hands%20gently%20opening%20a%20beautiful%20hardcover%20book%20on%20a%20warm%20wooden%20desk%2C%20soft%20natural%20light%20creating%20a%20peaceful%20reading%20atmosphere%2C%20a%20cup%20of%20tea%20and%20reading%20glasses%20nearby%2C%20educational%20and%20inviting%20mood%20with%20cream%20and%20terracotta%20tones%2C%20learning%20and%20knowledge%20photography%20with%20cozy%20intellectual%20aesthetic&width=600&height=240&seq=link-works-v2&orientation=landscape'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Mulebuy Spreadsheet Safety Guide',
      desc: 'Security and verification best practices explained',
      url: '/article/mulebuy-spreadsheet-safety-tips',
      image: 'https://readdy.ai/api/search-image?query=Minimalist%20security%20concept%20with%20a%20glass%20shield%20icon%20on%20a%20clean%20desk%20beside%20a%20laptop%2C%20soft%20diffused%20daylight%20from%20a%20large%20window%2C%20calm%20and%20trustworthy%20atmosphere%20with%20sage%20green%20and%20warm%20white%20tones%2C%20cybersecurity%20and%20protection%20photography%20with%20serene%20and%20professional%20aesthetic&width=600&height=240&seq=link-safety-v2&orientation=landscape'
    },
    {
      icon: 'ri-swap-line',
      title: 'Best Alternatives to Mulebuy Spreadsheet',
      desc: 'Honest comparison of alternative sourcing solutions',
      url: '/article/mulebuy-spreadsheet-vs-alternatives',
      image: 'https://readdy.ai/api/search-image?query=Two%20laptops%20placed%20side%20by%20side%20on%20a%20long%20wooden%20table%20showing%20different%20interfaces%2C%20a%20person%20contemplating%20between%20options%2C%20warm%20ambient%20lighting%20from%20overhead%20pendant%2C%20decision%20making%20and%20comparison%20concept%20with%20amber%20and%20cream%20tones%2C%20business%20choice%20photography%20with%20balanced%20and%20thoughtful%20composition&width=600&height=240&seq=link-alts-v2&orientation=landscape'
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Beginner Usage Tutorial',
      desc: 'Step-by-step getting started with practical examples',
      url: '/article/mulebuy-spreadsheet-beginners-guide',
      image: 'https://readdy.ai/api/search-image?query=Overhead%20flat%20lay%20of%20a%20laptop%20with%20a%20tutorial%20video%20playing%20on%20screen%20surrounded%20by%20colorful%20sticky%20notes%2C%20a%20highlighter%20pen%2C%20and%20a%20coffee%20mug%2C%20organized%20and%20inspiring%20learning%20setup%20on%20a%20light%20wooden%20desk%2C%20creative%20and%20educational%20atmosphere%20with%20warm%20neutral%20tones%2C%20tutorial%20and%20self%20improvement%20photography&width=600&height=240&seq=link-tutorial-v2&orientation=landscape'
    },
  ];

  return (
    <section className="w-full py-16 md:py-24 bg-background-100">
      <div className="max-w-6xl mx-auto px-6 md:px-8 lg:px-12">
        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 text-center">
          Explore Mulebuy Spreadsheet Resources
        </h2>
        <p className="mt-3 text-sm text-foreground-500 font-sans text-center max-w-xl mx-auto">
          To fully understand the ecosystem of <strong>Mulebuy spreadsheet tools</strong>, explore these dedicated resource pages with in-depth guides and comparisons.
        </p>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {links.map((link) => (
            <Link
              key={link.title}
              to={link.url}
              className="group flex flex-col bg-white rounded-xl border border-background-200 hover:border-accent-200 hover:shadow-sm transition-all duration-300 cursor-pointer overflow-hidden"
            >
              <div className="relative overflow-hidden" style={{ aspectRatio: '5/2' }}>
                <img
                  src={link.image}
                  alt={link.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
              </div>
              <div className="flex items-start gap-4 p-5">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-50 text-accent-600 flex-shrink-0 group-hover:bg-accent-100 transition-colors">
                  <i className={`${link.icon} text-lg`}></i>
                </div>
                <div>
                  <h3 className="font-sans text-sm font-semibold text-foreground-950 group-hover:text-accent-700 transition-colors">
                    {link.title}
                  </h3>
                  <p className="mt-1 text-xs text-foreground-400 font-sans">{link.desc}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <p className="mt-6 text-center text-xs text-foreground-400 font-sans">
          Each section expands the <strong>Mulebuy spreadsheet knowledge graph</strong>, improving your decision accuracy.
        </p>
      </div>
    </section>
  );
}